import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Customer {
  create = async (customer: any) => {
    const res = await axios.post<any>(`${API_URL}customer`, customer)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data.customer;
  };

  edit = async (customer: any, code: any) => {
    await axios.put(`${API_URL}customer/${code}`, customer)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}customer/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.customer;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}customer`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.customer;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}customer-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.customer;
  };
  sendSms = async (customer: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}outstanding-sms`,
      data: customer,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };
  
  sendproductStatus = async (customer: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}send-product-sms`,
      data: customer,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

}
export default new Customer();
